import {
  Container,
  Header,
  SpaceBetween,
  Grid,
} from "@cloudscape-design/components-themed";
import { CompanyInfoForBankAccount } from "../../../features/api-interfaces";
import { changeStyle } from "../../../utils/format";
import InfoField from "../../UI/InfoField";
import { LABELS } from "../constants";

interface IApplicantCompany {
  applicantCompany?: CompanyInfoForBankAccount;
}

/**
 * 入金口座情報照会・更新 事業者情報
 */
export const ApplicantCompany = (props: IApplicantCompany) => {
  const { applicantCompany } = props;
  const postalCode = applicantCompany?.postalCode;
  const displayAddress = [
    postalCode ? changeStyle(postalCode) : "　",
    "　",
    applicantCompany?.address ?? "　",
  ].join("");

  return (
    <Container
      header={<Header variant="h2">{LABELS.COMPANY_INFO_TITLE}</Header>}
    >
      <SpaceBetween direction={"vertical"} size={"xxs"}>
        <Grid
          gridDefinition={[
            { colspan: 1 },
            { colspan: 5 },
            { colspan: 1 },
            { colspan: 5 },
          ]}
        >
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.COMPANY_NAME]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[applicantCompany?.companyName]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.CORPORATE_NUMBER]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[applicantCompany?.corporateNumber]}
          />
        </Grid>
        <Grid
          gridDefinition={[
            { colspan: 1 },
            { colspan: 5 },
            { colspan: 1 },
            { colspan: 5 },
          ]}
        >
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.COMPANY_NAME_KANA]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[applicantCompany?.companyNameKana]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.COMPANY_NAME_ALPHABETICAL]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[applicantCompany?.companyNameAlphabetical]}
          />
        </Grid>
        <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.ADDRESS]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[displayAddress]}
          />
        </Grid>
        <Grid gridDefinition={[{ colspan: 1 }, { colspan: 11 }]}>
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"h4"}
            values={[LABELS.PHONE_NUMBER]}
          />
          <InfoField
            direction={"vertical"}
            size={"xxs"}
            tag={"p"}
            values={[applicantCompany?.phoneNumber]}
          />
        </Grid>
      </SpaceBetween>
    </Container>
  );
};
